module.exports = __webpack_public_path__ + "img/progress-coin.e842911c.svg";